import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATE_DELETE_SUBAFFILIATE_CONDITION_API_URL,
  AFFILIATE_DELETE_SUBAFFILIATE_CONDITION_MUTATION,
  AFFILIATE_SUBAFFILIATE_SETTINGS,
} from '../constants';

export default function useAffiliateSubaffiliateConditionDeleteMutation(): IContextMutationResult<void, Error, number> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [AFFILIATE_DELETE_SUBAFFILIATE_CONDITION_MUTATION],
    mutationFn: (itemId) => fetchDelete<void>(
      AFFILIATE_DELETE_SUBAFFILIATE_CONDITION_API_URL,
      {
        permission: AFFILIATE_SUBAFFILIATE_SETTINGS.HISTORY_CHANGES_DELETE,
        urlParams: {
          itemId,
        },
      },
    ),
    onSuccess() {
      displayPresetToast('removed');
    },
  });
}
